<template>
  <div class="value" :class="colorClass">{{processedValue}}</div>
</template>

<script>
  import { beautifyPercentValue } from 'src/utils/helpers';

  export default {
    props: {
      value: [Number, String],
    },
    computed: {
      processedValue() {
        return beautifyPercentValue(this.value);
      },
      colorClass() {
        return this.value < 0 ? 'value_red' : 'value_green';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .value {
    display: inline-block;
    &:after {
      content: '%';
    }
    &_red {
      color: $red-color3;
    }
    &_green {
      color: $green-color1;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/uikit/PercentTrend.vue